import { RoleType } from '@csp/dmdp-api-common-dto';
import { ConsentConfigOnFeatureV1 } from './ConsentConfigOnFeatureV1';
import { ConsentPlatform } from './ConsentPlatform';

export const CONSENT_CONFIG_V1_META_NAME = 'CONFIG_V1';

export type ConsentConfigMetaV1 = {
  roles: Array<RoleType>;
  platform: ConsentPlatform;
  onFeature: Array<ConsentConfigOnFeatureV1>;
  mandatory: boolean;
  /** whether or not the consent is linked to any data processing (enables / disabled specific withdrawal actions in the patient app) */
  dataProcessing: boolean;
  /** whether or not the consent can be accepted again after being withdrawn */
  enableReconsent: boolean;
};
